// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.company_info_YChVI {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.h4_W8wmX {
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 15px;
  color: #165ca9;
}
.small_RSq4e {
  display: block;
  font-size: 12px;
  color: gray;
}
.barcode_xa2HN {
  margin-left: auto;
  width: 150px;
  height: 80px;
}
.h3_span_qcsvx {
  font-size: 2.5em;
  /* Adjust the font size as needed */
  font-weight: 700;
  color: #165ca9;
  margin-top: 10px;
  margin-bottom: 5px;
}
.signature_dpL9U {
  margin-left: auto;
}
.custom_row_Tk4TE {
  margin-bottom: 20px;
  /* Adjust the value as needed to increase the gap */
}
.page_LgPqT {
  padding: 0 30px;
}
.breakhere_B7yf7 {
  page-break-after: always;
}
.page-break-before_OkXlm {
  page-break-before: always;
  border-bottom: 1px solid black;
}
/* Avoid breaking an element across pages */
.avoid-page-break_C2WQV {
  border-bottom: 1px solid black;
  page-break-inside: avoid;
}
.p_KRyqF {
  padding-bottom: 8px;
  font-size: 11pt !important;
  text-align: justify;
}
.ul_FVbCv {
  font-size: 10pt !important;
}
.col_sm_PmGwt {
  width: 100%;
  margin-left: 5px;
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Clients/RegisteredClients/Partnership/Buttons/Compliance/AntimoneyLaundering/antiMoney.less"],"names":[],"mappings":"AAAA,eAAe;AACf;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AAEA;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGA;EACI,cAAA;EACA,eAAA;EACA,WAAA;AADJ;AAIA;EACI,iBAAA;EACA,YAAA;EACA,YAAA;AAFJ;AAIA;EACI,gBAAA;EAFF,mCAAmC;EAGjC,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGA;EACI,iBAAA;AADJ;AAIA;EACI,mBAAA;EAFF,mDAAmD;AACrD;AAGA;EACI,eAAA;AADJ;AAIA;EACI,wBAAA;AAFJ;AAIA;EACI,yBAAA;EACA,8BAAA;AAFJ;AACA,2CAA2C;AAK3C;EACI,8BAAA;EACA,wBAAA;AAHJ;AAKA;EACI,mBAAA;EAEA,0BAAA;EACA,mBAAA;AAJJ;AAMA;EAEI,0BAAA;AALJ;AAOA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AALJ","sourcesContent":["/* styles.css */\n.company_info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.h4 {\n    margin-top: 5px;\n    margin-bottom: 15px;\n    font-size: 15px;\n    color: #165ca9;\n}\n\n.small {\n    display: block;\n    font-size: 12px;\n    color: gray;\n}\n\n.barcode {\n    margin-left: auto;\n    width: 150px;\n    height: 80px;\n}\n.h3_span {\n    font-size: 2.5em; /* Adjust the font size as needed */\n    font-weight: 700;\n    color: #165ca9;\n    margin-top: 10px;\n    margin-bottom: 5px;\n}\n.signature {\n    margin-left: auto;\n}\n\n.custom_row {\n    margin-bottom: 20px; /* Adjust the value as needed to increase the gap */\n}\n.page {\n    padding: 0 30px;\n}\n\n.breakhere {\n    page-break-after: always;\n}\n.page-break-before {\n    page-break-before: always;\n    border-bottom: 1px solid black;\n}\n\n/* Avoid breaking an element across pages */\n.avoid-page-break {\n    border-bottom: 1px solid black;\n    page-break-inside: avoid;\n}\n.p {\n    padding-bottom: 8px;\n    // font-family: Arial, Helvetica, sans-serif !important;\n    font-size: 11pt !important;\n    text-align: justify;\n}\n.ul {\n    // font-family: Arial, Helvetica, sans-serif !important;\n    font-size: 10pt !important;\n}\n.col_sm {\n    width: 100%;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n// @media print {\n//     .body {\n//       width: 210mm;\n//       height: 297mm; }\n\n//     .col_sm_12 {\n//       float: left;\n//       padding: 0; }\n\n//     .col_sm_12 {\n//       width: 100%; }\n\n//     .div[data-size=\"A4\"] {\n//       margin: 0;\n//       -webkit-box-shadow: 0;\n//               box-shadow: 0;\n//       padding: 3em 5em !important; }\n\n//     .breadcrumb,\n//     .subheader {\n//       display: none; }\n//     *:not(.keep_print_font) {\n//       font-family: Arial, Helvetica, sans-serif !important;\n//       font-size: 11pt !important; }\n//     .table {\n//       font-size: 100% !important; } }\n\n//   @page {\n//     size: auto;\n//     margin: 0; }\n\n//   .preview-footer {\n//       margin: 0 auto;\n//       background: url(../../../../../../../Assest/Svg/pattern-2.svg) no-repeat;\n//       position: absolute;\n//       bottom: 0;\n//       width: 100%;\n//       left: 0;\n//       height: 15px;\n//   }\n\n//   @media only screen and (max-width: 992px) {\n//     .div[data-size=\"A4\"],\n//     .container {\n//       padding: 0;\n//       -webkit-box-shadow: none;\n//               box-shadow: none; } }\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"company_info": `company_info_YChVI`,
	"h4": `h4_W8wmX`,
	"small": `small_RSq4e`,
	"barcode": `barcode_xa2HN`,
	"h3_span": `h3_span_qcsvx`,
	"signature": `signature_dpL9U`,
	"custom_row": `custom_row_Tk4TE`,
	"page": `page_LgPqT`,
	"breakhere": `breakhere_B7yf7`,
	"page-break-before": `page-break-before_OkXlm`,
	"avoid-page-break": `avoid-page-break_C2WQV`,
	"p": `p_KRyqF`,
	"ul": `ul_FVbCv`,
	"col_sm": `col_sm_PmGwt`
};
export default ___CSS_LOADER_EXPORT___;
